// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 拉二维码 GET /work_wx/contact_way_info */
export async function workWxContactWayInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.workWxContactWayInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultWwxWayResp>('/work_wx/contact_way_info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
